// extracted by mini-css-extract-plugin
export var actionButton = "_rt-0";
export var actionMenuContainer = "_rt-i";
export var bubble = "_rt-2";
export var bubbleActionMenu = "_rt-j";
export var bubbleContext = "_rt-6";
export var bubbleItems = "_rt-7";
export var customer = "_rt-3";
export var divider = "_rt-8";
export var fileList = "_rt-9";
export var hiddenComment = "_rt-o";
export var infoAbove = "_rt-a";
export var internal = "_rt-4";
export var lightActionButton = "_rt-1";
export var link = "_rt-b";
export var merchant = "_rt-5";
export var message = "_rt-c";
export var profilePicture = "_rt-e";
export var quillToolbarContainer = "_rt-f";
export var senderDate = "_rt-g";
export var senderDateCustomer = "_rt-h";
export var senderName = "_rt-d";
export var time = "_rt-k";
export var uploadedImage = "_rt-l";
export var username = "_rt-m";
export var xsmall = "_rt-n";